import React, { useState, useEffect } from "react";
import { Grid, Box, Container, Alert } from "@mui/material";
import axiosInstance from '../../interceptor/interceptor';
import { useLocation, Link } from 'react-router-dom';
//Components
import IndexHeader from "../../Components/IndexHeader";
import Footer from "../../Components/Footer";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const VerifyAccount = () => {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);

    // access query parameters
    const token = queryParams.get("token");
    const [ifPageValid, setIfPageValid] = React.useState(false);
    const [errMsg, setErrMsg] = React.useState("");
    const [successMsg, setSuccessMsg] = React.useState("");

    useEffect(()=>{
        validateToken();
    }, []);

    const validateToken = async () =>{
        try{
            const res = await axiosInstance.post(
                `api?method=verify_email`,
                {token:token}
            );
            if(res.data.status == 200){
                setSuccessMsg(res.data.message);
            }
            else {
                setIfPageValid(false);
                setErrMsg(res.data.message);
            }
        } catch (e) {
            setIfPageValid(false);
            setErrMsg(e.response?.data?.message || 'Something went wrong.');
        }
    }
    
  return (
    <>
      <IndexHeader />

      <Grid container>
        <Container maxWidth="lg" className="header-container-1" style={{marginTop:"200px"}}>
            {/* <Typography variant="h2" component="h3" className="form-heading" style={{fontWeight:'500', padding:'10px 0px', textAlign:'center',fontSize:'24px', marginTop:"50px", marginBottom:"50px"}}>Enter New Password</Typography> */}
            
            <Grid container  style={{ justifyContent:'center'}}>
                {/* <Grid item xs={4}></Grid> */}
                <Grid item xs={8} md={4} >
                    
                    {successMsg && <>
                        <Alert severity="success">{successMsg}</Alert>
                        <Link type="button" className="btn-small bg-dark shadow text-white td-none fw-b pos-cent mt-2"to="/login">Click to Log in</Link>
                    </>}
                    {errMsg && <Alert severity="error">{errMsg}</Alert>}
                </Grid>
            </Grid>

        </Container>
      </Grid>
      <Grid container style={{position: "fixed", bottom: "0"}}>
      <Footer />
      </Grid>
      
    </>
  );
};

export default VerifyAccount;
